import { Box } from "@chakra-ui/react";
import { POSTS_TYPE_VALUE_ARTICLE } from "@raiden/library/constants/posts";
import SearchInfiniteProvider from "@raiden/library/contexts/SearchInfinite/SearchInfiniteProvider";
import { useSearchInfinite } from "@raiden/library/contexts/SearchInfinite/useSearchInfinite";
import { useRouterString } from "@raiden/library/hooks/router/useRouterString";
import generateApiUrl from "@raiden/library/libraries/utils/generateApiUrl";
import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import CenteredContent from "../../../components/CenteredContent";
import { PageLayout } from "../../../components/PageLayout";
import { Filters } from "./Filters";
import { Results } from "./Results";

/**
 * @typedef {object} NewsSearchFormValues
 * @property {string} term
 */

/** @type {NewsSearchFormValues} */
export const NEWS_SEARCH_FORM_DEFAULT_VALUES = {
  term: "",
};

export function NewsSearch() {
  const intl = useIntl();

  const term = useRouterString("term");

  /** @type {import("@raiden/library/contexts/SearchInfinite/SearchInfiniteProvider").SearchInfiniteContextValue<NewsSearchFormValues>} */
  const searchInfiniteContext = useSearchInfinite({
    defaultValues: NEWS_SEARCH_FORM_DEFAULT_VALUES,
    initialFields: useMemo(
      () => ({
        term: term ?? "",
      }),
      [term],
    ),
    generateUrl: useCallback(
      (fields, key) =>
        generateApiUrl({
          id: "@api.posts.viewAny",
          query: {
            ...fields,
            page: key + 1,
            per_page: 8,
            type: [POSTS_TYPE_VALUE_ARTICLE],
            fields: [
              "post.current_revision",
              "post.categories",
              "post.revision.cover",
            ],
          },
        }),
      [],
    ),
    useRouterUrl: true,
    autoSubmit: false,
  });

  return (
    <PageLayout
      title={intl.formatMessage({ defaultMessage: "Actualités" })}
      description={intl.formatMessage({
        defaultMessage: "Nos conseils d'experts",
      })}>
      <Box px="1rem" pb="4rem">
        <SearchInfiniteProvider {...searchInfiniteContext}>
          <CenteredContent>
            <Filters />
          </CenteredContent>

          <Box>
            <CenteredContent maxWidth="calc(1320px + 32px)">
              <Results />
            </CenteredContent>
          </Box>
        </SearchInfiniteProvider>
      </Box>
    </PageLayout>
  );
}
